!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.BetterWebStorage = e() : t.BetterWebStorage = e();
}(window, function () {
  return function (t) {
    var e = {};
    function r(o) {
      if (e[o]) return e[o].exports;
      var i = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }
    return r.m = t, r.c = e, r.d = function (t, e, o) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) r.d(o, i, function (e) {
        return t[e];
      }.bind(null, i));
      return o;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 1);
  }([function (t) {
    t.exports = {
      a: "0.1.0"
    };
  }, function (t, e, r) {
    "use strict";

    r.r(e), function (t) {
      r.d(e, "default", function () {
        return i;
      });
      var o = r(0);
      class i {
        get version() {
          return o.a;
        }
        constructor(e) {
          const {
            local: r,
            session: o,
            prefix: i
          } = e;
          if (!r && !o) throw Error("local or session option is required.");
          if (r && o) throw Error("must select either local or session, not both.");
          if (i && (this.prefix = i), r && (this._storage = (window || t).localStorage), o && (this._storage = (window || t).sessionStorage), !this._storage) throw Error("storage method does not exist.");
        }
        key(t) {
          return this.prefix ? [this.prefix, t].join("_") : t;
        }
        filterPrefixedKeys() {
          const t = new RegExp("^" + this.key(""));
          return Object.keys(this._storage).filter(e => t.test(e));
        }
        strippedPrefix(t) {
          const e = this.key("");
          return t.map(t => t.replace(e, ""));
        }
        set(t, e) {
          if (!t) throw Error("key is required");
          if (t.constructor !== Object) return this._storage.setItem(this.key(t), JSON.stringify(e));
          Object.keys(t).forEach(e => {
            this.set(e, t[e]);
          });
        }
        get(t) {
          if (!t) throw Error("key is required");
          if (arguments.length > 1) return Array.from(arguments).map(t => [t, this.get(t)]).reduce((t, _ref) => {
            let [e, r] = _ref;
            return t[e] = r, t;
          }, {});
          const e = this._storage.getItem(this.key(t));
          return e ? JSON.parse(e) : e;
        }
        has(t) {
          if (!t) throw Error("key is required");
          return arguments.length > 1 ? -1 === Array.from(arguments).map(t => this.has(t)).indexOf(!1) : this._storage.hasOwnProperty(this.key(t));
        }
        rmv(t) {
          if (!t) throw Error("key is required");
          return arguments.length > 1 && Array.from(arguments).forEach(t => this.rmv(t)), this._storage.removeItem(this.key(t));
        }
        clear() {
          if (this.prefix) {
            const t = this.strippedPrefix(this.filterPrefixedKeys());
            return this.rmv(...t);
          }
          this._storage.clear();
        }
        get length() {
          return this.prefix ? this.filterPrefixedKeys().length : this._storage.length;
        }
        get all() {
          let t = this.filterPrefixedKeys();
          return this.prefix && (t = this.strippedPrefix(t)), console.log(t), this.get(...t);
        }
        assign(t, e) {
          const r = this.get(t);
          if (e.constructor !== Object) throw Error("value must be an object");
          if (r.constructor !== Object) throw Error("item is not an object");
          Object.assign(r, e), this.set(t, r);
        }
        each(t) {
          if (t.constructor !== Function) throw Error("argument is not a function");
          Object.entries(this.all).forEach(e => t(...e));
        }
        map(t) {
          if (t.constructor !== Function) throw Error("argument is not a function");
          return Object.entries(this.all).map(e => t(...e));
        }
      }
    }.call(this, r(2));
  }, function (t, e) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }
    t.exports = r;
  }]).default;
});